import { createTeamResourceContext } from './createTeamResourceContext'
import useAddressesResources from '../shared/resources/api/v1/admin/networking/useAddressesResources'

const { Provider: AddressesProvider, useHook: useAddresses } = createTeamResourceContext({
  name: 'Addresses',
  useResources: useAddressesResources,
  responseKey: 'addresses',
  requestOptions: { params: { publicOnly: true, limit: 1000 } },
  lookups: [{ key: 'addressesById', field: 'id' }],
  groupings: [{ key: 'addressesByNodeId', field: 'nodeId' }],
})

export { AddressesProvider, useAddresses }
